<template bindable="icon, heading, intro">
  <div class="as-page-jumbo">
    <div class="as-page-jumbo__icon" if.bind="icon">
      <span><i class="${icon}"></i></span>
    </div>
    <div class="as-page-jumbo__main">
      <h1 if.bind="heading">${heading}</h1>
      <p if.bind="intro">${intro}</p>
      <div class="as-page-jumbo__content">
        <slot name="default"></slot>
      </div>
    </div>
  </div>
</template>
